import { create } from 'zustand';

/**
 * Angeheftete Elemente je Projekt (IDs der Einträge, in der Reihenfolge des Anheftens): Sie stehen rechts neben dem Text und verknüpfen
 * die Markierung ohne den Referenz-Browser. Der Browser merkt sie sich (nur Bequemlichkeit); gelöschte Einträge fallen beim Anzeigen weg.
 */
const STORE_KEY = 'dispositio.pins';
type Saved = Record<string, string[]>;

function load(): Saved {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : {};
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    const out: Saved = {};
    for (const [project, ids] of Object.entries(parsed)) if (Array.isArray(ids)) out[project] = ids.filter((x): x is string => typeof x === 'string');
    return out;
  } catch {
    return {};
  }
}
function save(s: Saved): void {
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify(s));
  } catch {
    // privates Fenster o. Ä.: gilt bis zum Neuladen
  }
}

const NONE: string[] = [];

interface RefPins {
  byProject: Saved;
  /** anheften bzw. lösen */
  toggle: (projectId: string, entityId: string) => void;
}

export const useRefPins = create<RefPins>((set, get) => ({
  byProject: load(),
  toggle: (projectId, entityId) => {
    const ids = get().byProject[projectId] ?? NONE;
    const next = ids.includes(entityId) ? ids.filter((id) => id !== entityId) : [...ids, entityId];
    const byProject = { ...get().byProject };
    if (next.length > 0) byProject[projectId] = next;
    else delete byProject[projectId];
    set({ byProject });
    save(byProject);
  },
}));

/** Die angehefteten Elemente eines Projekts */
export const usePinnedIds = (projectId: string): string[] => useRefPins((s) => s.byProject[projectId] ?? NONE);
